module.exports = __webpack_public_path__ + "img/main_ipad.a80784a4.png";